module.exports = __webpack_public_path__ + "img/shop-slash.12ac8ecd.svg";